import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HappyPayBankAccountService } from '@features/user/services/happy-pay-bank-account.service';
import { HappyPayWithdrawalService } from '@features/user/services/happy-pay-withdrawal.service';
import { faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'fc-user-happy-pay-withdrawal-add-dialog',
  templateUrl: './user-happy-pay-withdrawal-add-dialog.component.html',
  styleUrls: ['./user-happy-pay-withdrawal-add-dialog.component.css'],
})
export class UserHappyPayWithdrawalAddDialogComponent implements OnInit {
  faSpinner = faSpinner;
  faTimes = faTimes;
  withdrawalForm: FormGroup;
  bankAccountDropdown: any = [];
  isSubmitted: boolean = false;
  loading: boolean = false;

  constructor(
    private hpBankAccService: HappyPayBankAccountService,
    private happyPayWithdrawalService: HappyPayWithdrawalService,
    private router: Router,
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig
  ) {
    this.withdrawalForm = new FormGroup({
      amount: new FormControl(null, Validators.required),
      to_bank_account_id: new FormControl('', Validators.required),
    });
  }

  ngOnInit(): void {
    this.hpBankAccService
      .getHappyPayBankAccounts()
      .subscribe((bankAccounts) => {
        if (bankAccounts) {
          for (let account of bankAccounts) {
            this.bankAccountDropdown.push({
              label: `${account.account_no} - ${account.account_name}`,
              value: account.id,
            });
          }
        }
      });
  }

  onSubmit() {
    this.isSubmitted = true;
    if (this.withdrawalForm.valid) {
      this.loading = true;
      this.happyPayWithdrawalService
        .addHappyPayWithdrawal(this.withdrawalForm.value)
        .subscribe(
          (res) => {
            this.loading = false;
            this.happyPayWithdrawalService.setNewHpWithdrawState(res);
            this.router.navigate(['/user/happy-pay/withdrawal']);
            this.dismissModal();
          },
          (error) => {
            this.loading = false;
          }
        );
    }
  }

  dismissModal() {
    this.ref.close();
  }
}
